import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameCityImprovement} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameCityImprovement'
import {UIMGameCityImprovementProgressTrackerController} from './UIMGameCityImprovementProgressTrackerController'
import {MechanicCityImprovementsState, MechanicRobberState} from '@colonist/game-states'

/**
 * @deprecated UIMGameCityImprovement will be removed once Pixi.js Mobile Player Information view is removed. Please use UIGameCityImprovement.
 */
export class UIMGameCityImprovement extends UIGameCityImprovement {
    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState, robberState: MechanicRobberState | undefined) {
        super(uiGameManager, cityImprovementsState, robberState)
        this.createCityImprovementProgressTrackerController()
    }

    private createCityImprovementProgressTrackerController() {
        new UIMGameCityImprovementProgressTrackerController(this.uiGameManager, this.cityImprovementsState)
    }
}
